// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selWidth[data-v-cb6f1512] {\n  width: 219px !important;\n}\n.seachTiele[data-v-cb6f1512] {\n  line-height: 35px;\n}\n.btnBottom[data-v-cb6f1512] {\n  padding: 10px 0 20px 0;\n}", ""]);
// Exports
module.exports = exports;
